export default class DtoPollutedSoil {
    constructor(obj) {
        this.id = obj.id
        this.icpeCode = obj.icpeCode
        this.activityCode = obj.activityCode
    }
}